import { AppState } from '../../types/store';
import { ModulePriv } from '../../types/modules';

export const getModuleType = (state: AppState, moduleId: number) =>
  state?.modules?.[moduleId]?.type;

export const getModuleVersion = (state: AppState, moduleId: number) =>
  state?.modules?.[moduleId]?.version;

export const getModuleData = (state: AppState, moduleId: number) =>
  state?.modules?.[moduleId]?.moduleData || {};

export const getModulePrivileges = (state: AppState, moduleId: number) =>
  state?.modules?.[moduleId]?.privileges || {};

export const getModuleConfig = (state: AppState, moduleId: number) =>
  state?.modules?.[moduleId]?.moduleConfig || {};

export const getModuleMeta = (state: AppState, moduleId: number) =>
  state?.modules?.[moduleId]?.moduleMeta || {};

export const getModuleDataByModuleType = (
  state: AppState,
  moduleType: string
) => {
  const moduleRaw = findModules(state, m => m.type === moduleType).pop() || {};
  return moduleRaw.moduleData || {};
};

export const getModuleIdByModuleType = (
  state: AppState,
  moduleType: string
) => {
  const moduleRaw = findModules(state, m => m.type === moduleType).pop() || {};
  return moduleRaw.id || undefined;
};

export const getModules = (state: AppState) => state.modules || {};

export const hasModuleTypeInstalled = (state: AppState, moduleType: string) => {
  let hasIt = false;
  const modules = getModules(state);
  Object.keys(modules).forEach(moduleId => {
    if (modules[moduleId]['type'] === moduleType) {
      hasIt = true;
    }
  });
  return hasIt;
};

export const findModules = (state: AppState, predicate: (m: any) => boolean) =>
  Object.keys(state.modules)
    .filter(key => predicate(state.modules[key]))
    .map(key => state.modules[key]);

export const getModulesByModuleIds = (state: AppState, moduleIds: number[]) =>
  findModules(state, m => moduleIds.includes(m.id));

export const getSectionModuleDataByModuleType = (
  state: AppState,
  sectionName: string,
  moduleType: string
) => {
  const zones = state.layout?.[sectionName]?.zones || {};
  const allInstalledModuleIds = Object.keys(zones).reduce(
    (acc, zoneName) => acc.concat(zones[zoneName]?.installedModulesIds || []),
    [] as number[]
  );
  const sectionModules = getModulesByModuleIds(state, allInstalledModuleIds);
  const moduleRaw = sectionModules.find(m => m.type === moduleType);
  return moduleRaw?.moduleData || {};
};

export const canPerformModuleAction = (
  state: AppState,
  moduleId: number,
  priv: ModulePriv
) => getModulePrivileges(state, moduleId)[priv] !== false; // assume true by default
